import './firebase/bootstrap';
import { getApp } from 'firebase/app';
import {
  getAnalytics,
  logEvent,
  setUserId,
  setUserProperties,
} from 'firebase/analytics';
import {
  getFunctions,
  httpsCallable,
  type HttpsCallableResult,
} from 'firebase/functions';

export { remoteConfig } from './firebase/remoteConfigClient';

const app = getApp();

function getAnalyticsInstance() {
  try {
    return getAnalytics(app);
  } catch {
    return undefined;
  }
}

export const firebaseApp = app;

export const analytics = {
  logEvent(eventName: string, params?: Record<string, unknown>) {
    const instance = getAnalyticsInstance();
    if (instance) {
      logEvent(
        instance,
        eventName as string,
        params as Record<string, string | number | boolean> | undefined,
      );
    }
  },
  setUserId(userId: string) {
    const instance = getAnalyticsInstance();
    if (instance) {
      setUserId(instance, userId);
    }
  },
  setUserProperties(properties: Record<string, unknown>) {
    const instance = getAnalyticsInstance();
    if (instance) {
      setUserProperties(
        instance,
        properties as Record<string, string | number | boolean>,
      );
    }
  },
  setCurrentScreen(screenName: string, options?: Record<string, unknown>) {
    const instance = getAnalyticsInstance();
    if (!instance) return;

    const params: Record<string, string | number | boolean> = { screen_name: screenName };
    if (options && typeof options === 'object') {
      Object.assign(params, options);
    }
    logEvent(instance, 'screen_view' as string, params as Record<string, string | number | boolean>);
  },
};

const functionsInstance = getFunctions(app);

export const functions = {
  httpsCallable<T = unknown, R = unknown>(name: string) {
    return httpsCallable<T, R>(functionsInstance, name);
  },
};

export type { HttpsCallableResult };
